import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTeams = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 224 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter0_d_1497_5164)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-1-inside-1_1497_5164",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M94.3201 17.9609L93.3397 18.1576L106.715 84.8292L107.695 84.6325L108.676 84.4358L95.3006 17.7642L94.3201 17.9609ZM106.128 86.9869L105.931 86.0064L23.5721 102.529L23.7688 103.509L23.9655 104.49L106.325 87.9673L106.128 86.9869ZM21.4145 101.942L22.3949 101.745L9.01971 35.0734L8.03924 35.2701L7.05878 35.4667L20.434 102.138L21.4145 101.942ZM9.60678 32.9157L9.80348 33.8962L92.1625 17.3739L91.9658 16.3934L91.7691 15.4129L9.41009 31.9353L9.60678 32.9157ZM8.03924 35.2701L9.01971 35.0734C8.91108 34.5319 9.26198 34.0048 9.80348 33.8962L9.60678 32.9157L9.41009 31.9353C7.7856 32.2612 6.73288 33.8423 7.05878 35.4667L8.03924 35.2701ZM23.7688 103.509L23.5721 102.529C23.0306 102.637 22.5036 102.286 22.3949 101.745L21.4145 101.942L20.434 102.138C20.7599 103.763 22.341 104.816 23.9655 104.49L23.7688 103.509ZM107.695 84.6325L106.715 84.8292C106.824 85.3707 106.473 85.8978 105.931 86.0064L106.128 86.9869L106.325 87.9673C107.949 87.6414 109.002 86.0603 108.676 84.4358L107.695 84.6325ZM94.3201 17.9609L95.3006 17.7642C94.9747 16.1397 93.3936 15.087 91.7691 15.4129L91.9658 16.3934L92.1625 17.3739C92.704 17.2652 93.2311 17.6161 93.3397 18.1576L94.3201 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-1-inside-1_1497_5164)"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#clip0_1497_5164)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M56.4717 55.2995L50.7349 62.2916M56.4717 55.2995L64.4614 59.5379M56.4717 55.2995L62.8432 51.4714L64.4614 59.5379M56.4717 55.2995L49.1167 54.2252L50.7349 62.2916M56.4717 55.2995L58.7337 66.5748M64.4614 59.5379L60.8883 62.0629L61.6751 65.9847L58.7337 66.5748M50.7349 62.2916L55.0055 63.243L55.7923 67.1649L58.7337 66.5748",
						stroke: "var(--token-color-border)",
						strokeWidth: 1.5,
						strokeLinejoin: "bevel"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter1_d_1497_5164)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-4-inside-2_1497_5164",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.415 17.9609L130.395 18.1576L117.02 84.8292L116.039 84.6325L115.059 84.4358L128.434 17.7642L129.415 17.9609ZM117.607 86.9869L117.804 86.0064L200.163 102.529L199.966 103.509L199.769 104.49L117.41 87.9673L117.607 86.9869ZM202.32 101.942L201.34 101.745L214.715 35.0734L215.696 35.2701L216.676 35.4667L203.301 102.138L202.32 101.942ZM214.128 32.9157L213.931 33.8962L131.572 17.3739L131.769 16.3934L131.966 15.4129L214.325 31.9353L214.128 32.9157ZM215.696 35.2701L214.715 35.0734C214.824 34.5319 214.473 34.0048 213.931 33.8962L214.128 32.9157L214.325 31.9353C215.949 32.2612 217.002 33.8423 216.676 35.4667L215.696 35.2701ZM199.966 103.509L200.163 102.529C200.704 102.637 201.231 102.286 201.34 101.745L202.32 101.942L203.301 102.138C202.975 103.763 201.394 104.816 199.769 104.49L199.966 103.509ZM116.039 84.6325L117.02 84.8292C116.911 85.3707 117.262 85.8978 117.804 86.0064L117.607 86.9869L117.41 87.9673C115.786 87.6414 114.733 86.0603 115.059 84.4358L116.039 84.6325ZM129.415 17.9609L128.434 17.7642C128.76 16.1397 130.341 15.087 131.966 15.4129L131.769 16.3934L131.572 17.3739C131.031 17.2652 130.504 17.6161 130.395 18.1576L129.415 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-4-inside-2_1497_5164)"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#clip1_1497_5164)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M160.893 59.2802L165.804 60.2653M160.893 59.2802L160.606 64.4866M160.893 59.2802L161.993 56.6294M164.328 67.626L165.804 60.2653M164.328 67.626L169.154 66.2015M164.328 67.626L160.606 64.4866M170.715 61.2505L165.804 60.2653M170.715 61.2505L169.154 66.2015M170.715 61.2505L170.723 58.3808M169.154 66.2015L170.806 67.8728L170.501 69.3909M160.606 64.4866L158.256 65.3551L157.951 66.8732M170.731 55.5111L167.189 53.3647L163.092 53.9786M170.731 55.5111L173.325 55.3136L173.648 53.7035M170.731 55.5111L170.723 58.3808M163.092 53.9786L160.775 52.7959L161.098 51.1858M163.092 53.9786L161.993 56.6294M161.993 56.6294L160.083 56.2463L158.311 56.9436M170.723 58.3808L172.633 58.7639L173.999 60.0907",
						stroke: "var(--token-color-border)",
						strokeWidth: 1.5,
						strokeLinejoin: "bevel"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_1497_5164)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-7-inside-3_1497_5164",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V102C155.646 103.105 154.751 104 153.646 104H69.646C68.5414 104 67.646 103.105 67.646 102V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V102C155.646 103.105 154.751 104 153.646 104H69.646C68.5414 104 67.646 103.105 67.646 102V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z",
					fill: "var(--token-color-bg)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.646 34H154.646V102H155.646H156.646V34H155.646ZM153.646 104V103H69.646V104V105H153.646V104ZM67.646 102H68.646V34H67.646H66.646V102H67.646ZM69.646 32V33H153.646V32V31H69.646V32ZM67.646 34H68.646C68.646 33.4477 69.0937 33 69.646 33V32V31C67.9891 31 66.646 32.3431 66.646 34H67.646ZM69.646 104V103C69.0937 103 68.646 102.552 68.646 102H67.646H66.646C66.646 103.657 67.9891 105 69.646 105V104ZM155.646 102H154.646C154.646 102.552 154.198 103 153.646 103V104V105C155.303 105 156.646 103.657 156.646 102H155.646ZM155.646 34H156.646C156.646 32.3431 155.303 31 153.646 31V32V33C154.198 33 154.646 33.4477 154.646 34H155.646Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-7-inside-3_1497_5164)"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .6,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M119.302 68L115.302 73L111.242 75V68M119.302 68L115.302 63L111.242 61V68M119.302 68H105.302M111.242 68L105.302 63V68M111.242 68L105.302 73V68",
						stroke: "var(--token-color-accent)",
						strokeWidth: 1.5,
						strokeLinejoin: "bevel"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_1497_5164",
				x: -.354004,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5164"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5164",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_1497_5164",
				x: 107.646,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5164"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5164",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_1497_5164",
				x: 59.646,
				y: 26,
				width: 104,
				height: 88,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5164"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5164",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_1497_5164",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 28,
					height: 28,
					fill: "white",
					transform: "translate(68.8403 43.4711) rotate(78.6563)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_1497_5164",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 28,
					height: 28,
					fill: "white",
					transform: "matrix(-0.196695 0.980465 0.980465 0.196695 154.895 43.4711)"
				})
			})
		] })
	]
});
export default SvgEmptyTeams;
